import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch, RootState } from 'interfaces';

import Layout from 'components/Layout';
import SongsComponent from 'components/Songs';
import StatisticSideBar from 'components/StatisticSideBar';

import { getBasicBandStats, getMostPlayedAlbums, getMostPlayedSongs } from 'features/statistics/statisticsSlice';

import { loadSongs } from './songsSlice';

const Songs = () => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(loadSongs());
  }, [dispatch]);

  const songs = useSelector((state: RootState) => state.songs.songs);

  useEffect(() => {
    dispatch(getMostPlayedSongs({ tourId: null, albumId: null, limit: 10 }));
    dispatch(getMostPlayedAlbums({ tourId: null }));
    dispatch(getBasicBandStats());
  }, [dispatch]);

  const mostPlayedSongs = useSelector((state: RootState) => state.statistics.mostPlayedSongs);
  const mostPlayedAlbums = useSelector((state: RootState) => state.statistics.mostPlayedAlbums);
  const bandStats = useSelector((state: RootState) => state.statistics.bandStats);

  return (
    <Layout sidebar={(
      <StatisticSideBar
        context="allSongs"
        mostPlayedSongs={mostPlayedSongs}
        mostPlayedAlbums={mostPlayedAlbums}
        bandStats={bandStats}
      />
    )}>
      <SongsComponent songs={songs} />
    </Layout>
  );
};

export default Songs;
